import client from './client';

export const getCtaCollection = async (slug: string): Promise<SanityCtaCollection> => {
  const query = `
  *[slug.current=="${slug}"][0]{
    _id,
    'boxes':boxes[]->{
        _id,
        bgColor{
            alpha,
            hex
        },
        bottomHeaderText->{textContent},
        bottomHeaderColor{
            alpha,
            hex
        },
        buttonBackgroundColor{
            alpha,
            hex
        },
        buttonTextColor{
          alpha,
          hex
        },
        buttonLabel->{textContent},
        buttonLink,
        buttonLinkMode,
        bgImage{
            asset->{url},
        },
        descImage{
            asset->{url},
            alt
        },
        description->{textContent},
        descriptionColor{
            alpha,
            hex
        },
        dateTextColor{
          alpha,
          hex
        },
        slug,
        title,
        topHeaderText->{textContent},
        topHeaderColor{
            alpha,
            hex
        },
        campaignStartDate,
        campaignEndDate,
        eventStartDate,
        eventEndDate
    }
  }
  `;

  const data = await client.fetch<SanityCtaCollection>(query);

  return data;
};
